
module.exports = function br_tag(md) {
  md.inline.ruler.push('br', function replace(state, silent) {
    const expect = '<br>';
    const tagLength = expect.length;
    const start = state.pos;

    if (state.src.charAt(start) !== '<') {
      return false;
    }

    const tag = state.src.substr(start, tagLength);
    if (tag !== expect) {
      return false;
    }

    state.pos = start + tagLength;

    if (silent) {
      return true;
    }

    state.push('br_tag', 'br');

    return true;
  });
};
